import { Slide } from 'react-awesome-reveal';
import { Box, Stack, Typography } from '@mui/material';
import { Fade } from 'react-awesome-reveal';
import { Section1 } from './componenets/Section1';
import Footer from '../footer/FooterSection';
import Navbar from '../navbar/Navbar';
import sectionConstants from '../constants/SectionConstants';
import './PrivacyPolicy.scss';

export const PrivacyPolicy = () => {
  return (
    <Box className='privacy-policy-page'>
      <Box id='top' className='privacy-policy-image'>
        <Box>
          <Navbar />
        </Box>
        <Stack className='privacy-policy-heading' spacing={2}>
          <Typography className='privacy-policy-heading-data1'>
            <Slide>{sectionConstants.PrivacyPolicy}</Slide>
          </Typography>
        </Stack>
      </Box>
      <Section1 />
      <Footer />
    </Box>
  );
};
